import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper, Typography, ListSubheader, Divider, Tooltip, Link } from '@material-ui/core';
import List from '@material-ui/core/List';
import { formatValue } from "utilities/format";
import Stack from "components/layout/Stack";

function BoxContainer({ children, type = 'paper', ...props }) {    
	if (type === 'paper') {
		return (
			<Paper {...props}>
				{children}
			</Paper>
		);
	} else {
		return (
			<div {...props}>
				{children}
			</div>
		);
	}
}

const VerticalDetailsBox = ({ classes, dataItem, fields, title, visible = true, headerImageURL, hasMoreButton, onMoreButtonClick,
	hasViewUnderwriteButton, onViewUnderwriteButtonClick, headerElement, footerElement, containerType = 'paper', contentPadding = 0, ...props 
}) => {  
	const [expanded, setExpanded] = useState(false);
	if (!visible || !dataItem || !fields) return null;

	//console.log(dataItem);
	const hasSomeData = fields.some(f => dataItem[f.dataField] != null);
	const hasExpandOption = fields && fields.filter(f => f.extraField && dataItem[f.dataField] != null).length > 0;
	const titleMaxLength = 35;
	const shortTitle = title && title.length > titleMaxLength ? title.substring(0,titleMaxLength) + '...' : title;        
	return (        
		<BoxContainer type={containerType} {...props}>
			{
				headerElement
			}
			{
				headerImageURL &&
					<div className={classes.headerImageContainer}>
						<img
							className={classes.headerImage}
							alt={title}
							src={headerImageURL}
						/>
					</div>
							
			}                
			<List
				className={classes.list}
				dense
				subheader={
					title && title !== "" &&
					<ListSubheader>
						<Stack horizontal className={classes.subheaderContainer}>
							<Tooltip title={shortTitle !== title ? title : ''} placement="top">
								<Typography variant="subtitle2" noWrap={true}>{shortTitle && shortTitle !== "" ? shortTitle : "-n/a-"}</Typography>
							</Tooltip>                                
						</Stack>
						<Divider style={{marginTop: 3}} />
					</ListSubheader>
				}
			>
				<table className={classes.contentsContainer} style={{padding: contentPadding}}>
				<tbody>
				{hasSomeData 
					? fields.filter(field => dataItem[field.dataField] != null).map(field => {
						return (
							<tr key={field.dataField} style={{display: !field.extraField || (field.extraField && expanded) ? "" : "none"}}>
								<td style={{paddingRight: 10}}>
									<Typography variant="caption" color="inherit">{field.caption}</Typography>
								</td>
								<td>
									<Typography variant="caption" color="textSecondary" align="right">
										{formatValue(dataItem[field.dataField], field.format, false, "N/A")}
									</Typography>
								</td>                                  
							</tr>
					)})
					: <Typography variant="caption" color="textSecondary">No Data</Typography>
				}
				</tbody>
				</table>
				{
					hasExpandOption &&
					<div style={{textAlign: "center", paddingBottom: 5}}>
						<Link
							component="button"
							variant="caption"
							onClick={() => setExpanded(!expanded)}
							style={{textDecoration: 'none'}}
						>
							{expanded ? "▲" : "▼"}
						</Link>
					</div>
				}
			</List>
			{footerElement}
		</BoxContainer>
	)
}

const alignCenter = {
	margin: '0 auto'
}

const styles = theme => ({
	root: {
		position: 'absolute',
	},
	left: {
		left: 10,
	},
	right: {
		right: 10
	},
	list: {
		minWidth: 200,
		paddingBottom: 0
	},
	contentsContainer: {        
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	subheaderContainer: {
		...alignCenter,
		paddingTop: 10,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	headerImageContainer: {
		...alignCenter,
		marginLeft: 10,
		marginRight: 10,
		marginTop: 10,
		paddingTop: 10,
	},
	headerImage: {
		...alignCenter,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	}
});

export default withStyles(styles)(VerticalDetailsBox);